import type { ColumnSort } from '@tanstack/react-table';
import type { ExtractSort } from '.';

export const sortMapper = <T extends { sort?: unknown[] }>(sort: ColumnSort): ExtractSort<T>[] => {
  return [`${sort.desc ? '-' : '+'}${sort.id}`];
};
